import * as React from 'react'

interface VerticalFilmPlaceholderProps {
  title?: string
  className?: string
}

export const VerticalFilmPlaceholder: React.FC<VerticalFilmPlaceholderProps> = ({
  title,
  className,
}) => {
  return (
    <div
      className={`relative aspect-[1/2] rounded-2xl bg-gradient-to-br from-neutral-800 to-neutral-900 overflow-hidden border border-white/10 shadow-xl ${className ?? ''}`}
    >
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_20%_0,rgba(212,175,55,0.25),transparent_55%),radial-gradient(circle_at_80%_100%,rgba(74,31,184,0.4),transparent_55%)]" />
      <div className="relative z-10 flex h-full flex-col justify-end p-3">
        <p className="text-[10px] uppercase tracking-wide text-white/60 mb-1">Binyuma Original</p>
        <p className="text-xs font-semibold text-white line-clamp-2">
          {title ?? 'New vertical series coming soon'}
        </p>
      </div>
    </div>
  )
}

